const LocalLogout = () => {
    return (
        <div>
            <h1>Local Logout page</h1>
        </div>
    );
};

export default LocalLogout;